import * as signalR from '@microsoft/signalr';
import Url from 'url-parse';
import qs from 'query-string';
import { bus } from './event';

const BASE_URL = new Url(process.env.VUE_APP_LOCAL_API as string).href;

export default class SignalHub {
  private static connection: signalR.HubConnection;

  static invokeMessage: string

  private static async connect() {
    const { connection } = SignalHub;

    try {
      await connection.start();

      connection.on('GetNotificationCount', (count) => {
        bus.$emit('get-notification-count', count);
      });
      connection.invoke(SignalHub.invokeMessage);
    } catch (err) {
      connection.onclose(() => SignalHub.connect());
    }
  }

  static start(userId: number, cdAgent?: string) {
    const query = qs.stringify({ userId, cdAgent }, { skipNull: true });
    SignalHub.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${BASE_URL}HubNotification?${query}`)
      .configureLogging(signalR.LogLevel.Information)
      .withAutomaticReconnect()
      .build();

    setTimeout(() => {
      SignalHub.connect();
    }, 1000);
  }
}
